import { Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useToggle } from '/@/hooks/toggle/useToggle';
import { _ } from '/@/locale';
import BayerModal from '../bayer/modal';

const PrivacyDisclaimer = ({
    message = _(
        'La siguiente funcionalidad contiene información sensible de la compañía y compartirlo con gente ajena a la organización puede tener implicancias legales negativas.'
    ),
    warning,
    crop,
    title = _('Contenido sensible'),
}: {
    crop: string;
    warning: string;
    title?: string;
    message?: string;
}) => {
    const { open: showDisclaimer, toggle } = useToggle();

    useEffect(() => {
        toggle();
    }, []);

    return (
        <BayerModal
            open={showDisclaimer}
            setClose={toggle}
            handleClick={toggle}
            title={title}
            variant='children'
            buttonText={_('Aceptar')}
            warning={warning}
        >
            <Stack spacing={2} sx={{ px: 2 }}>
                <Typography variant='body1' color='primary' align={'center'}>
                    {message}
                </Typography>

                {warning && (
                    <Typography variant='body1' color='primary' align={'center'}>
                        {warning}
                    </Typography>
                )}
            </Stack>
        </BayerModal>
    );
};

export default PrivacyDisclaimer;
